import React from "react";
var __jsx = React.createElement;
import classes from "./AffSection2.module.css";
import { useTranslation } from "@i18n";
var AffSection2 = function AffSection2() {
  var _useTranslation = useTranslation(["web_affiliate_program", "web_common"]),
    t = _useTranslation.t,
    tLong = _useTranslation.tLong;
  return /*#__PURE__*/React.createElement("section", {
    className: classes.AffiliateSection2
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", classes.containerMaxWidt].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mrkProgCont
  }, /*#__PURE__*/React.createElement("img", {
    className: "m-show",
    src: "/assets/bundles/wqerm.png",
    alt: t("affiliate_program", {
      ns: "web_affiliate_program"
    }),
    loading: "lazy",
    width: "390px",
    height: "auto"
  }), /*#__PURE__*/React.createElement("h1", null, t("affiliate_program", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("p", null, tLong("affiliate/program-promotion-description", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://syarah.trackier.com/register.html",
    className: ["redBtn", classes.mrkALink].join(" ")
  }, t("start_earning_today", {
    ns: "web_affiliate_program"
  })))));
};
export default AffSection2;